import { ComponentProps } from 'react';
import { Button } from '@/shared/ui/button';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Button> & {
    toId?: string;
};

const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const ScrollButton = ({ children, toId, ...props }: Props) => {
    const Element = toId ? 'a' : 'button';

    return (
        <Layout element={Button} asChild onClick={toId ? undefined : handleClick} {...props}>
            <Element href={toId ? `#${toId}` : undefined}>{children}</Element>
        </Layout>
    );
};
